import { IDisciplineData } from './IObraData';
import { IBaseResponse } from '../BaseResponse';

export interface IDisciplineResponse {
  ConstructionSiteDisciplinesId: number;
  ConstructionSiteFk: number;
  CustomName: string;
  Discipline: IDisciplineData;
  DisciplineApiFolderId: string;
  DisciplineFk: number;
  FolderStatus: DisciplineFolderStatusEnum;
}

export interface IDisciplineDataResponse extends IBaseResponse<IDisciplineResponse> {}

export enum DisciplineFolderStatusEnum {
  Sync = 0,
  NotFound = 1,
}
